export default __webpack_public_path__ + "static/media/Boots of the Bloodhunter.996ce98e.jpg";